import { useQuery } from "@tanstack/react-query";
import { getRebuildAPI } from "@rebuild/shared/api";
import { JobRecordStatus, type JobRecord } from "@rebuild/shared/models";
import { JOB_KEYS } from "./queryKeys";

const { jobControllerGetJobsForEstimateByEstimateId } = getRebuildAPI();

export const POLL_INTERVAL_MS = 1000;

export const isJobActive = (job: JobRecord): boolean => job.status === JobRecordStatus.queued || job.status === JobRecordStatus.processing;

export interface UseJobStatusOptions {
  enabled?: boolean;
}

export function useJobStatus(estimateId: string, options: UseJobStatusOptions = { enabled: true }) {
  return useQuery({
    queryKey: JOB_KEYS.forEstimate(estimateId),
    queryFn: async (): Promise<JobRecord[]> => {
      const { data } = await jobControllerGetJobsForEstimateByEstimateId(estimateId);
      return data ?? [];
    },
    enabled: !!estimateId && options.enabled,
    refetchInterval: (query) => {
      const jobs = query.state.data;
      if (!jobs || jobs.length === 0) return false;
      return jobs.some(isJobActive) ? POLL_INTERVAL_MS : false;
    },
    refetchIntervalInBackground: false,
  });
}
